define('GameDayCore/GDModel/ValueObjects/Gamecenter/CondensedGame',['require','exports','module','../ValueObjectFactory','../RealTimeHighlights/Highlight'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory'),
		Highlight = require("../RealTimeHighlights/Highlight");

	VO.create(CondensedGame);

	function CondensedGame($data) {
		var vo = VO.ensureVO(this, CondensedGame);
	    var data = $data;
		var condensed = parseList($data);
		vo.video = condensed;
	}

	function parseList($data) {
		var vids = [].concat($data.media),
			videoObj = { };

		for (var i = 0, long = vids.length; i < long; i++) {
			var hilite = new Highlight(vids[i]);
			if (hilite.condensed) { 
				return hilite;	
			}
		}
		
		return {};
	}
	return CondensedGame;
});
